<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Motorista
          </p>
          <div class="heading-elements">
            <i
              class="fas fa-long-arrow-alt-left position-left"
              @click="voltar()"
              style="cursor: pointer"
            ></i>
          </div>
        </div>
        <div class="box-body">
          <div v-show="errorMessage !== ''" class="alert alert-danger">
            {{ errorMessage }}
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="nome">Nome <sup class="text-danger">* </sup></label>
              <input
                id="nome"
                v-model="registro.nome"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.nome }"
              />
              <span v-show="errors.nome !== null" class="help-inline">{{
                errors.nome
              }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cpf">CPF <sup class="text-danger">* </sup></label>
              <input
                id="cpf"
                v-model="registro.cpf"
                v-mask="'###.###.###-##'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.cpf }"
              />
              <span v-show="errors.cpf !== null" class="help-inline">{{
                errors.cpf
              }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="email"
                >E-mail <sup class="text-danger">* </sup></label
              >
              <input
                id="email"
                v-model="registro.email"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.email }"
              />
              <span v-show="errors.email !== null" class="help-inline">{{
                errors.email
              }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="tel_celular"
                >Telefone <sup class="text-danger">* </sup></label
              >
              <input
                id="tel_celular"
                v-model="registro.tel_celular"
                v-mask="'(##) ####-#####'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.tel_celular }"
              />
              <span v-show="errors.tel_celular !== null" class="help-inline">{{
                errors.tel_celular
              }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_cep">CEP <sup class="text-danger">* </sup></label>
              <input
                id="end_cep"
                v-model="registro.end_cep"
                v-mask="'##.###-###'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_cep }"
                @keyup="pesquisarCEP()"
              />
              <span v-show="errors.end_cep !== null" class="help-inline">{{
                errors.end_cep
              }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_logradouro"
                >Logradouro <sup class="text-danger">* </sup></label
              >
              <input
                id="end_logradouro"
                v-model="registro.end_logradouro"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_logradouro }"
              />
              <span
                v-show="errors.end_logradouro !== null"
                class="help-inline"
                >{{ errors.end_logradouro }}</span
              >
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_numero"
                >Número <sup class="text-danger">* </sup></label
              >
              <input
                id="end_numero"
                v-model="registro.end_numero"
                v-mask="'##########'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_numero }"
              />
              <span v-show="errors.end_numero !== null" class="help-inline">{{
                errors.end_numero
              }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_complemento">Complemento </label>
              <input
                id="end_complemento"
                v-model="registro.end_complemento"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_complemento }"
              />
              <span
                v-show="errors.end_complemento !== null"
                class="help-inline"
                >{{ errors.end_complemento }}</span
              >
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_bairro"
                >Bairro <sup class="text-danger">* </sup></label
              >
              <input
                id="end_bairro"
                v-model="registro.end_bairro"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_bairro }"
              />
              <span v-show="errors.end_bairro !== null" class="help-inline">{{
                errors.end_bairro
              }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_cidade"
                >Cidade <sup class="text-danger">* </sup></label
              >
              <input
                id="end_cidade"
                v-model="registro.end_cidade"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_cidade }"
              />
              <span v-show="errors.end_cidade !== null" class="help-inline">{{
                errors.end_cidade
              }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_uf">UF <sup class="text-danger">* </sup></label>
              <select
                id="end_uf"
                v-model="registro.end_uf"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_uf }"
              >
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AM">AM</option>
                <option value="AP">AP</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MG">MG</option>
                <option value="MS">MS</option>
                <option value="MT">MT</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="PR">PR</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="RS">RS</option>
                <option value="SC">SC</option>
                <option value="SE">SE</option>
                <option value="SP">SP</option>
                <option value="TO">TO</option>
              </select>
              <span v-show="errors.end_uf !== null" class="help-inline">{{
                errors.end_uf
              }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_pais"
                >País <sup class="text-danger">* </sup></label
              >
              <select
                id="end_pais"
                v-model="registro.end_pais"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_pais }"
              >
                <option value="0639">ARGENTINA</option>
                <option value="0973">BOLIVIA</option>
                <option value="1058">BRASIL</option>
                <option value="1589">CHILE</option>
                <option value="1694">COLOMBIA</option>
                <option value="2399">EQUADOR</option>
                <option value="2496">ESTADOS UNIDOS</option>
                <option value="4936">MEXICO</option>
                <option value="5860">PARAGUAI</option>
                <option value="5894">PERU</option>
                <option value="8451">URUGUAI</option>
                <option value="8508">VENEZUELA</option>
              </select>
              <span v-show="errors.end_pais !== null" class="help-inline">{{
                errors.end_pais
              }}</span>
            </div>
          </div>
        </div>
        <div class="box-footer text-center">
          <div class="btn-group">
            <button
              type="button"
              id="cancelButton"
              class="btn btn-warning"
              @click="voltar()"
            >
              Cancelar
            </button>
            <button
              type="button"
              id="gravarButton"
              class="btn btn-success"
              @click="gravar()"
            >
              Gravar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { isValidCep, isValidCpf } from "@brazilian-utils/validators";
import MotoristaActions from "../../actions/MotoristaActions";
import { validate as isEmail } from "email-validator";

export default {
  name: "novo",
  data() {
    return {
      errorMessage: "",
      errors: {},
      hasError: false,
      registro: {
        nome: "",
        email: "",
        cpf: "",
        tel_celular: "",
        end_cep: "",
        end_logradouro: "",
        end_numero: "",
        end_complemento: "",
        end_bairro: "",
        end_cidade: "",
        end_uf: "",
        end_pais: ""
      }
    };
  },
  mounted() {
    this.$parent.$parent.$data.description = "Novo";
  },
  methods: {
    voltar() {
      this.$router.push("/motoristas/listar-ativos");
    },
    pesquisarCEP() {
      if (isValidCep(this.registro.end_cep)) {
        if (this.ultimoCEP !== this.registro.end_cep) {
          this.$parent.$parent.$data.showModalLoader = true;
          this.ultimoCEP = this.registro.end_cep;
          MotoristaActions.pesquisarCep(this.registro.end_cep)
            .then(res => {
              this.registro.end_logradouro = res.logradouro;
              this.registro.end_bairro = res.bairro;
              this.registro.end_cidade = res.localidade;
              this.registro.end_uf = res.uf;
              this.errors.end_cep = null;
              this.cepNaoEncontrado = false;
              this.$parent.$parent.$data.showModalLoader = false;
            })
            .catch(erro => {
              this.registro.end_logradouro = "";
              this.registro.end_bairro = "";
              this.registro.end_cidade = "";
              this.registro.end_uf = "";
              this.errors.end_cep = "CEP não encontrado.";
              this.cepNaoEncontrado = true;
              this.$parent.$parent.$data.showModalLoader = false;
            });
        }
      }
    },
    validation() {
      this.errors = {};
      this.hasError = false;
      if (!this.registro.nome) {
        this.errors.nome = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.email) {
        this.errors.email = "Este campo deve ser preenchido.";
        this.hasError = true;
      } else if (!isEmail(this.registro.email)) {
        this.errors.email = "E-mail inválido.";
        this.hasError = true;
      } else {
        MotoristaActions.verificarEmailEmUso(this.registro.email, this.id).then(
          emUso => {
            if (emUso) {
              this.errors.email = "E-mail já em uso por outro usuário.";
              this.hasError = true;
            }
          }
        );
      }
      if (!this.registro.cpf) {
        this.errors.cpf = "Este campo deve ser preenchido.";
        this.hasError = true;
      } else if (!isValidCpf(this.registro.cpf)) {
        this.errors.cpf = "CPF inválido.";
        this.hasError = true;
      }
      if (!this.registro.tel_celular) {
        this.errors.tel_celular = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.end_cep) {
        this.errors.end_cep = "Este campo deve ser preenchido.";
        this.hasError = true;
      } else if (this.cepNaoEncontrado) {
        this.errors.end_cep = "CEP não encontrado.";
        this.hasError = true;
      }
      if (!this.registro.end_logradouro) {
        this.errors.end_logradouro = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.end_numero) {
        this.errors.end_numero = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.end_bairro) {
        this.errors.end_bairro = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.end_cidade) {
        this.errors.end_cidade = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.end_uf) {
        this.errors.end_uf = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
      if (!this.registro.end_pais) {
        this.errors.end_pais = "Este campo deve ser preenchido.";
        this.hasError = true;
      }
    },
    async gravar() {
      this.validation();
      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true;
        await MotoristaActions.cadastrarMotoristaAdmin(
          {
            nome: this.registro.nome,
            email: this.registro.email,
            cpf: this.registro.cpf,
            tel_celular: this.registro.tel_celular,
            end_cep: this.registro.end_cep,
            end_logradouro: this.registro.end_logradouro,
            end_numero: this.registro.end_numero,
            end_complemento: this.registro.end_complemento,
            end_bairro: this.registro.end_bairro,
            end_cidade: this.registro.end_cidade,
            end_uf: this.registro.end_uf,
            end_pais: this.registro.end_pais
          },
          this,
          "motoristas/listar-ativos",
          "AUTH0_CONNECTION_DB_PWADRIVER"
        );
        this.voltar();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/motorista/Novo.vue